import React, { useEffect, useRef } from 'react'
import { FaTimes } from 'react-icons/fa'
import { FcDownload, FcLike } from 'react-icons/fc'

function Modal({
  image,
  user,
  download,
  likes,
  profile_image,
  setModal,
  modal,
  html,
}) {
  const value = useRef(null)
  const closeModal = (setModal) => {
    setModal(false)
    document.documentElement.style.overflow = 'scroll'
  }
  const change = () => {
    if (window.innerHeight <= 700) {
      value.current.style.top = `${window.scrollY + 335}px`
      document.documentElement.style.overflow = 'hidden'
    }
    if (window.innerHeight >= 700) {
      value.current.style.top = `${window.scrollY + 360}px`
      document.documentElement.style.overflow = 'hidden'
    }
    if (window.innerHeight >= 800) {
      value.current.style.top = `${window.scrollY + 420}px`
      document.documentElement.style.overflow = 'hidden'
    }
    if (window.innerHeight >= 900) {
      value.current.style.top = `${window.scrollY + 460}px`
      document.documentElement.style.overflow = 'hidden'
    }
  }
  useEffect(() => {
    change()
  }, [modal])
  console.log(window.innerHeight)
  return (
    <div className='modal' ref={value}>
      <div className='close' onClick={() => closeModal(setModal)}>
        <FaTimes />
      </div>
      <div className='user-profile'>
        <a href={html}>
          <img src={profile_image} alt='' />
          <h4 className='name'>{user}</h4>
        </a>
      </div>
      <div className='full-image'>
        <img src={image} alt='' />
      </div>
      <div className='like'>
        <h4>
          <FcLike />
          <span>{likes}</span>
          likes
        </h4>
      </div>
      <div className='download'>
        <a href={download}>
          <FcDownload />
        </a>
      </div>
    </div>
  )
}

export default Modal
